<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
   <a-form-item label="微信名称">
      <a-input v-model:value="search.member_name" style="width:220px" placeholder="请输入微信名称进行搜索"></a-input>
    </a-form-item>
   <a-form-item label="商品名称">
      <a-input v-model:value="search.goods_name" style="width:220px" placeholder="请输入商品名称进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="奖项名称">
      <a-input v-model:value="search.award_name" style="width:220px" placeholder="请输入奖项名称进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="核销门店" >
      <a-input v-model:value="search.write_store" style="width:220px" placeholder="请输入核销门店进行搜索"></a-input>
    </a-form-item>
    <!-- <a-form-item label="" name='keywords'>
      <a-input-group compact :style="{width:'360px'}">
        <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
          <a-select-option value="member_name">微信昵称</a-select-option>
          <a-select-option value="award_name">奖项名称</a-select-option>
          <a-select-option value="award_content">奖品名称</a-select-option>
          <a-select-option value="receiv_name">核销门店</a-select-option>
        </a-select>
        <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
      </a-input-group>
    </a-form-item> -->
    <a-form-item label="领奖时间" name='time' >
        <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD'  @change="onChange"   v-model:value="time" style="width:220px" />
    </a-form-item>
    <a-form-item label="订单号" >
        <a-input v-model:value="search.order_no" style="width:220px" placeholder="请输入订单号进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="状态" name='award_status' >
      <a-select  v-model:value="search.award_status" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="0">待核销</a-select-option>
        <a-select-option :value="1">已过期</a-select-option>
        <a-select-option :value="2">已核销</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item >
      <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
      <a-button class="m-r-10" v-has:marketinOrderExport='exportTable'>导出</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='list' :scroll="{ x: 'max-content'}" class="tableFixBox">
    <template v-slot:award_info="{ record }">
      <div v-if='record.award_info.length == 1'>
        <div v-for="(item,index) in record.award_info" :key='index'>
          <a-card-meta>
            <template #avatar>
              <img class="table_img" :src="info.picdomain+(item.cover_image_url)" alt="">
            </template>
            <template #description>
              <p class="s_omit2" >{{item.gift_name}}</p>
              <!-- <p class="s_c333">({{record.award_name}})</p> -->
            </template>
          </a-card-meta>
        </div>
      </div>
      <div class="s_flex_ali" v-else>
        <div v-for="(item,index) in record.award_info" :key='index'>
          <img class="m-r-10 table_img" :src="info.picdomain+(item.cover_image_url)" alt="">
        </div>
        <p class="s_c333">({{record.award_name}})</p>
      </div>
    </template>
    <template v-slot:write_gift_store="{ record }">
      <p>{{record.write_gift_store || '-'}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a-button v-has:marketingOrderDetail="()=>{showDetail=true;scan_award_id=record.id}" type="link">详情</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal title="订单详情" :keyboard="false" centered v-model:visible="showDetail" :width='1000' :footer="null" destroyOnClose :bodyStyle="{'height':'80vh',
  'overflowY': 'scroll'}">
    <orderDetail :scan_award_id='scan_award_id'></orderDetail>
  </a-modal>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { getPageState } from "@/utils/pageState";
import { getEntityList,entityawardExport} from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
import store from "@/store";
import  orderDetail from "./orderDetail";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  key_type:'',
  keyword: "",
  start_time:'',
  end_time:'',
  award_status:'',
  is_write:1,
  member_name:'',
  order_no:'',
  award_name:'',
  write_store:'',
  goods_name:''
};
export default {
  components: { orderDetail },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let list = ref([]);
    const state = reactive({
      showDetail:false,
      info: store.state.user.info,
      showDeliver:false,
      listLoading: false,
      time:[],
      total: 0,
      scan_award_id:""
    });
    let columns =ref( [
      {
        title:"订单号",
        dataIndex: "sn",
        key: "sn",
        align:'center',
      },
     
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
         align:'center'
      },
      {
        title: "商品信息",
        dataIndex: "award_info",
        key: "award_info",
        width:300,
        slots: { customRender: "award_info" },
      },
       {
        title: "领奖时间",
        dataIndex: "receiv_time",
        key: "receiv_time",
        align:'center',
        customRender: ({record }) => {
          return record.receiv_time ?record.receiv_time:'-'
        }
      },
       {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
        align:'center'
      },
       {
        title: "奖项名称",
        dataIndex: "award_name",
        key: "award_name",
         align:'center'
      },
     
    
      {
        title: "状态",
         align:'center',
        dataIndex: "award_status_title",
        key: "award_status_title",
      },
        {
        title: "核销门店",
        dataIndex: "write_gift_store",
        key: "write_gift_store",
         align:'center',
        slots: { customRender: "write_gift_store" },
      },
      {
        title: "操作",
        key: "action",
        fixed: 'right',
         align:'center',
        width:100,
        slots: { customRender: "action" },
      },
    ]);
    const $router = inject('$router')
    const $Modal = inject('$Modal')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
    }
    //获取列表
    const initData = async (values) => {
      list.value=[]
      state.listLoading = true;
      try {
        let res = await getEntityList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          list.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) =>{
      search.value.keyword = ''
    }
    
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });
    // 导出
    const exportTable=async()=>{
      const hide = message.loading('正在加载中...', 0);
      var json=JSON.parse(JSON.stringify(search.value))
      let result=await  entityawardExport(json).then(res=>res.data).catch(error=>error)
      setTimeout(hide);
      if(iscode(result,true)){
        window.open(result.data.url)
      }
    }
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      inputSelect,
      exportTable
    };
  },
};
</script>
